<template>
  <nav class="flex items-center">
    <span class="flex items-center paragraph-bold mr-200">
      <LcIcon class="mr-100" name="language" size="medium" />
      <p>{{ $t('locale') }}</p>
    </span>

    <LcSelectList
      v-bind="{ options, variant }"
      horizontal
      :option-component="SwitchLocalePathLink"
      :value="selectedLocale"
      @update:value="() => emit('optionClick')"
    />
  </nav>
</template>

<script lang="ts" setup>
import type { LcSelectListProps } from '@lottocom/frontend-components'

import { SwitchLocalePathLink } from '#components'

type LanguageSwitchEmit = {
  (event: 'optionClick'): void
}

type LanguageSwitchProps = Pick<LcSelectListProps, 'variant'>

const emit = defineEmits<LanguageSwitchEmit>()
defineProps<LanguageSwitchProps>()

const { options, selectedLocale } = useLanguageUtils()
</script>
